$(function(){
  $('.midashi').each(function () {
  const beforeContent = window
    .getComputedStyle(this, '::before')
    .getPropertyValue('content');

  if (beforeContent === '"✦"' || beforeContent === '✦') {
    $(this).addClass('no-before');
  }
  });
});


$(function() {
  
  const $gallery = $('.product-gallery').first();
  if (!$gallery.length) return;

  let switched = false;
  let userInteracted = false;

  // ユーザーがバリエーションを変更したらフラグ
  $(document).on('change', '[name^="options"], [name="id"]', function() {
    userInteracted = true;
  });

  // DOM変化監視
  const observer = new MutationObserver(function(mutations) {
    if (switched || userInteracted) return;

    // 任意のサムネを取得（例：1枚目）
    const $thumb = $gallery.find('.product-gallery__thumbnail').first();

    if ($thumb.length) {
      $thumb.trigger('click'); // 初期表示を切替
      switched = true;
      observer.disconnect(); // 1回だけ
    }
  });

  observer.observe($gallery.get(0), { childList: true, subtree: true });
});





$(function(){
  // sticky解除
  $(".product_detail_bottom").insertAfter(".product");
  $(".dl_wrapper").insertAfter(".product_detail_bottom");
  // Debounce function
  function debounceProduct(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // grid高さ調整
  const adjustGridHeight = debounceProduct(function() {
    var gridHeight = $('.product-gallery').height();
    $('.product_grid_container').css('grid-template-rows',gridHeight+'px');
  }, 250);
  
  $(window).on('load', adjustGridHeight);
  $(window).on('resize', adjustGridHeight);

// 検索窓を押したらカテゴリ出現
  $('input.header_search_word').focus(function(){
    $('.header__wrapper2').removeClass('hide'); 
    $('.header__main-nav').slideDown(0);
  });

  
});


$(window).on('load', function () {
  $('.giftease-recipient-form__field input').each(function(){
    var inputId = $(this).attr('id');
    if(inputId.indexOf("name") >= 0){
      $(this).attr('placeholder','受取人お名前');
    }
    if(inputId.indexOf("email") >= 0){
      $(this).attr('placeholder','受取人メールアドレス');
    }
  });
  $('.giftease-recipient-form__field textarea').attr('placeholder','メッセージ');
  $('.giftease-recipient-form__field label.giftease-recipient-form__field-label').html('送信日');
  $('.giftease-recipient-form__field').each(function(){
    var text = $(this).find('label.giftease-recipient-form__help-label span').html();
    if(text == 'Must be a future date. Leave blank to send immediately.'){
      $(this).find('label.giftease-recipient-form__help-label span').html('空欄もしくは過去の日付の場合はすぐに送信されます。');
    }
    if(text == '200 characters max'){
      $(this).find('label.giftease-recipient-form__help-label span').html('200文字まで');
    }
  });
});


const adjustImageHeight = debounceProduct(function() {
  var imgWidth = $('.product-gallery__media-list-wrapper').width();
  $('.product-gallery__media-list-wrapper').css('min-height',imgWidth+'px');
}, 250);

$(window).on('load', adjustImageHeight);
$(window).on('resize', adjustImageHeight);

// This scroll handler is already handled in header_hide.js
// Removing duplicate to prevent conflicts



